import axios from 'axios';
import BaseCrud from './baseCrud';
const crud = new BaseCrud('footer-link');

export const state = () => ({ ...crud.state });

export const getters = {
    ...crud.getters
};

export const mutations = {
    ...crud.mutations
};

export const actions = {
    ...crud.actions,

    getColumnCount(vuexContext, columnId) {
        return axios.$get(`/admin/footer-links/${columnId}/count`);
    }
};
